import React, { useState } from 'react';
import { translations } from '../translations';
import { FaTimes } from 'react-icons/fa';
import {submitContactForm} from "../api/contactService";

const Cta = ({ language }) => {
    const [isFormOpen, setIsFormOpen] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [submitStatus, setSubmitStatus] = useState(null);
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        company: '',
        phone: '',
        message: ''
    });

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        setSubmitStatus(null);

        try {
            await submitContactForm(formData);
            setSubmitStatus('success');
            setFormData({
                name: '',
                email: '',
                company: '',
                phone: '',
                message: ''
            });
            setTimeout(() => {
                setIsFormOpen(false);
                setSubmitStatus(null);
            }, 3000);
        } catch (error) {
            console.error('Error submitting form:', error);
            setSubmitStatus('error');
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <>
            <section className="cta-section" id="demo">
                <h3 className="chinese-font">{translations[language]['cta.title']}</h3>
                <p className="chinese-font">{translations[language]['cta.subtitle']}</p>
                <button
                    onClick={() => setIsFormOpen(true)}
                    className="btn btn-primary"
                >
                    {translations[language]['cta.cta']}
                </button>
            </section>

            {/* Contact Form Modal */}
            {isFormOpen && (
                <div className="contact-modal">
                    <div className="contact-modal-content">
                        <button
                            className="close-button"
                            onClick={() => {
                                setIsFormOpen(false);
                                setSubmitStatus(null);
                            }}
                        >
                            <FaTimes />
                        </button>

                        <h2 className="chinese-font">{translations[language]['form.title']}</h2>
                        <p className="chinese-font">{translations[language]['form.subtitle']}</p>

                        {submitStatus === 'success' ? (
                            <div className="alert alert-success">
                                {translations[language]['form.success']}
                            </div>
                        ) : submitStatus === 'error' ? (
                            <div className="alert alert-error">
                                {translations[language]['form.error']}
                            </div>
                        ) : (
                            <form onSubmit={handleSubmit}>
                                <div className="form-group">
                                    <label htmlFor="name" className="chinese-font">
                                        {translations[language]['form.name']}
                                    </label>
                                    <input
                                        type="text"
                                        id="name"
                                        name="name"
                                        value={formData.name}
                                        onChange={handleInputChange}
                                        required
                                    />
                                </div>

                                <div className="form-group">
                                    <label htmlFor="email" className="chinese-font">
                                        {translations[language]['form.email']}
                                    </label>
                                    <input
                                        type="email"
                                        id="email"
                                        name="email"
                                        value={formData.email}
                                        onChange={handleInputChange}
                                        required
                                    />
                                </div>

                                <div className="form-group">
                                    <label htmlFor="company" className="chinese-font">
                                        {translations[language]['form.company']}
                                    </label>
                                    <input
                                        type="text"
                                        id="company"
                                        name="company"
                                        value={formData.company}
                                        onChange={handleInputChange}
                                    />
                                </div>

                                <div className="form-group">
                                    <label htmlFor="phone" className="chinese-font">
                                        {translations[language]['form.phone']}
                                    </label>
                                    <input
                                        type="tel"
                                        id="phone"
                                        name="phone"
                                        value={formData.phone}
                                        onChange={handleInputChange}
                                    />
                                </div>

                                <div className="form-group">
                                    <label htmlFor="message" className="chinese-font">
                                        {translations[language]['form.message']}
                                    </label>
                                    <textarea
                                        id="message"
                                        name="message"
                                        value={formData.message}
                                        onChange={handleInputChange}
                                        rows="4"
                                    />
                                </div>

                                <button
                                    type="submit"
                                    className="btn btn-primary"
                                    disabled={isSubmitting}
                                >
                                    {isSubmitting ? translations[language]['form.submitting'] : translations[language]['form.submit']}
                                </button>
                            </form>
                        )}
                    </div>
                </div>
            )}
        </>
    );
};

export default Cta;
